import { Col, Row } from 'react-bootstrap';
import Image from 'next/image';

export default function IsoNavigation({ className }: { className: string }) {
  return (
    <Col className={className}>
      <h3>ISO certificeringen</h3>
      <Row className="pl-3 pt-1">
        <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
          <Image src="/images/footer/iso_9001.png" alt="ISO 9001" width={60} height={60} />
        </a>
        <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
          <Image src="/images/footer/iso_14001.png" alt="Vercel Logo" width={60} height={60} />
        </a>
        <a href="/over-ons/certificering" target="_blank" rel="noopener noreferrer">
          <Image src="/images/footer/issa-association.png" alt="Vercel Logo" width={72} height={40} />
        </a>
      </Row>
    </Col>
  );
}
